export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-GQEXW5M5S1";

function gtagSafe(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function trackPageView(pagePath, pageTitle = document.title) {
  gtagSafe("event", "page_view", {
    page_path: pagePath,
    page_title: pageTitle,
  });
}

export function trackEvent(eventName, params = {}) {
  gtagSafe("event", eventName, params);
}
